import { Pipe, PipeTransform } from '@angular/core';
import { PalantirLabelColors, palantirLabelColorsMap } from './labels.type';

@Pipe({
  name: 'labels'
})
export class LabelsPipe implements PipeTransform {
  public transform(value: PalantirLabelColors): {
    color: string;
    contrast: string;
  } {
    return palantirLabelColorsMap[value];
  }
}
